var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.063,
    height: 43.908,
    viewBox: "0 0 33.063 43.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invoice",
    transform: "translate(-47.592 -0.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16106",
    "data-name": "Path 16106",
    d: "M50.9,44.107a8.925,8.925,0,0,1-1.093-.419,3.5,3.5,0,0,1-1.951-3.1c-.028-.621-.007-1.243-.007-1.864V4.518A3.613,3.613,0,0,1,50.974.745a4.737,4.737,0,0,1,.718-.037Q60.931.7,70.171.7a1.476,1.476,0,0,1,1.126.465q4.32,4.34,8.661,8.661a1.428,1.428,0,0,1,.447,1.091q-.012,14.665-.007,29.328a3.614,3.614,0,0,1-2.95,3.8.405.405,0,0,0-.1.067H50.9Zm18.649-41.6H51.75a1.873,1.873,0,0,0-2.1,2.123V40.18A1.878,1.878,0,0,0,51.793,42.3h24.66A1.879,1.879,0,0,0,78.6,40.182V11.556H78.09q-2.351,0-4.7,0a4.468,4.468,0,0,1-.718-.039A3.6,3.6,0,0,1,69.55,7.868c-.008-1.764,0-3.53,0-5.36Zm1.8,1.386c0,1.333-.008,2.628,0,3.924A1.826,1.826,0,0,0,73.3,9.752c1.215.009,2.429,0,3.644,0a1.341,1.341,0,0,0,.233-.035c-1.935-1.934-3.858-3.858-5.825-5.825Z",
    fill: "#0b2ff7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16107",
    "data-name": "Path 16107",
    d: "M106.615,178.266q-4.828,0-9.655,0a1.777,1.777,0,0,1-.58-.078.872.872,0,0,1-.558-.944.889.889,0,0,1,.79-.762,4.252,4.252,0,0,1,.465-.012h19.183c.831,0,1.263.316,1.25.914-.012.582-.437.887-1.241.887h-9.655Z",
    transform: "translate(-42.54 -155.86)",
    fill: "#0b2ff7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16108",
    "data-name": "Path 16108",
    d: "M106.692,224.348h9.529c.155,0,.311,0,.465.007a.891.891,0,0,1,.858.875.909.909,0,0,1-.829.912,3.545,3.545,0,0,1-.381.007H97.067c-.113,0-.226,0-.339,0a.909.909,0,0,1-.879-.906.88.88,0,0,1,.892-.883c.719-.018,1.439-.008,2.16-.008h7.791Z",
    transform: "translate(-42.572 -198.318)",
    fill: "#0b2ff7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16109",
    "data-name": "Path 16109",
    d: "M106.7,274.1H97.083a3.188,3.188,0,0,1-.465-.012.906.906,0,0,1-.779-.913.889.889,0,0,1,.823-.865c.126-.012.254-.009.381-.009h19.31c.764,0,1.182.32,1.181.9s-.43.9-1.183.9h-9.655Z",
    transform: "translate(-42.562 -240.839)",
    fill: "#0b2ff7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16111",
    "data-name": "Path 16111",
    d: "M102.152,320.187h5.081c.142,0,.283,0,.424.009a.861.861,0,0,1,.826.854.885.885,0,0,1-.8.93,2.8,2.8,0,0,1-.339.008H96.971c-.71,0-1.136-.345-1.131-.91s.411-.889,1.147-.889q2.582,0,5.165,0Z",
    transform: "translate(-42.563 -283.306)",
    fill: "#0b2ff7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16112",
    "data-name": "Path 16112",
    d: "M181.954,128.532q2.582,0,5.165,0a2.073,2.073,0,0,1,.545.046.894.894,0,0,1,.613.913.91.91,0,0,1-.736.821,1.857,1.857,0,0,1-.337.018q-5.251,0-10.5,0a1,1,0,0,1-.944-.444.891.891,0,0,1,.818-1.356c1.313-.015,2.625,0,3.938-.006h1.439Z",
    transform: "translate(-113.308 -113.353)",
    fill: "#0b2ff7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16113",
    "data-name": "Path 16113",
    d: "M.645-11.48v-.959H1.7v-.817H.645v-.959H1.7v-3H3.089l1.87,3H7.481v-3H8.6v3H9.682v.959H8.6v.817H9.682v.959H8.6V-8.52H7.279L5.4-11.48H2.823V-8.52H1.7V-11.48Zm2.178-.959H4.8l-.521-.817H2.823Zm3.243,0H7.481v-.817H5.557ZM2.823-14.214h.852l-.852-1.344Zm4.658,4.042V-11.48H6.664Z",
    transform: "translate(52.629 25.5)",
    fill: "#0b2ff7",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.5ac0dc8bbf39d0497adc0684a13c926e.svg";
export { ForwardRef as ReactComponent };